export const ANONYMOUS_DASHBOARD_ID = -1
export const ANONYMOUS_USER_ID = "annonymous"
